import { Button, SafeArea } from "antd-mobile";
import SuccessIcon from "../assets/success.svg";
import FailIcon from "../assets/fail.svg";
import style from "./index.module.scss";
import { useLocation, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { queryCommonParam } from "../../../network/workUploadApi";

const ResultPage = () => {
  const { token } = useParams<{ token: string }>();

  const { status, msg } =
    useLocation<{ status: string; msg: string }>().state || {};
  const [successText, setSuccessText] = useState<string>("提交成功");

  const isSuccess = status === "success";
  const icon = isSuccess ? SuccessIcon : FailIcon;
  const text = isSuccess ? successText : "提交失败";

  useEffect(() => {
    const fetchTips = async () => {
      try {
        const res: any = await queryCommonParam({
          code: "customerUploadFileSmsTemplateCode",
          key: "submit_success",
          token,
        });
        const text = res.data?.data?.value;
        if (text) {
          const htmlString = text.replace(/\n/g, "<br />");
          setSuccessText(htmlString);
        }
      } catch (err) {}
    };
    fetchTips();
  }, [token]);

  const closePage = () => {
    window.open("", "_self")?.close();
    // window.close();
    window.history.back();
  };

  return (
    <div className={style.resultPage}>
      <img src={icon} className={style.resultIcon} alt="resultIcon" />
      <div
        className={style.resultText}
        dangerouslySetInnerHTML={{ __html: text }}
      />
      {!isSuccess && <div className={style.resultTip}>{msg}</div>}
      <div className={style.footer}>
        <Button block size="large" onClick={closePage}>
          确定
        </Button>
        <SafeArea position="bottom" />
      </div>
    </div>
  );
};

export default ResultPage;
